export const API_BASE_URL = (process.env.REACT_APP_IP_DASHBOARD_UI_BASE_API_URL || "https://poc-customer-dashboard-api-service-develop-737548590601.us-central1.run.app/").replace(/\/+$/, "");

export const ENDPOINTS = {
  BASE_URL: API_BASE_URL,
  LOGIN: `${API_BASE_URL}/api/v1/user/login`,
  VERIFY_TOKEN: `${API_BASE_URL}/api/v1/user/verify-token`,
  REGISTER_CLIENT: `${API_BASE_URL}/api/v1/user/register/client`,
  REGISTER_ADMIN: `${API_BASE_URL}/api/v1/user/register/admin`,
  REGISTER_MANAGER: `${API_BASE_URL}/api/v1/user/register/manager`,
  FILTER_USERS: `${API_BASE_URL}/api/v1/user/list/filter`,
  USER_LIST_ALL: `${API_BASE_URL}/api/v1/user/list/all`,
  USER_DETAILS: `${API_BASE_URL}/api/v1/user/details`,
  USER_UPDATE: `${API_BASE_URL}/api/v1/user/update`,
  USER_DELETE: `${API_BASE_URL}/api/v1/user/delete/one`,
  USER_SUBSCRIPTION: `${API_BASE_URL}/api/v1/user/subscription`,
  FILTER_PROJECTS: `${API_BASE_URL}/api/v1/project/list/filter`,
  PROJECT_DETAILS: `${API_BASE_URL}/api/v1/project/details`,
  PROJECT_ADD: `${API_BASE_URL}/api/v1/project/add`,
  PROJECT_EDIT: `${API_BASE_URL}/api/v1/project/edit`,
  PROJECT_DELETE: `${API_BASE_URL}/api/v1/project/delete/one`,
  PROJECT_LOGO_UPLOAD: `${API_BASE_URL}/api/v1/project/logo/upload`,
  PROJECT_SUPABASE_CLIENTS: `${API_BASE_URL}/api/v1/project/supabase-clients`,
  TRANSCRIPTS_LIST_ALL: `${API_BASE_URL}/api/v1/transcripts/list/all`,
  TRANSCRIPTS_EXPORT_CSV: `${API_BASE_URL}/api/v1/transcripts/export/csv`,
  PROJECT_LIST_ALL: `${API_BASE_URL}/api/v1/project/list/all`,
  INTERACTION_COUNTS: `${API_BASE_URL}/api/v1/transcripts/count/interactions`,

  ANALYTICS_METRICS: `${API_BASE_URL}/api/v1/analytics/metrics`,
  ANALYTICS_GROWTH: `${API_BASE_URL}/api/v1/analytics/growth`,
  ANALYTICS_ACTIVITY: `${API_BASE_URL}/api/v1/analytics/activity`,

  UPDATE_CONVERSATION: `${API_BASE_URL}/api/v1/conversations/update`,

  // AI Analysis endpoints
  AI_ANALYZE_TAG: `${API_BASE_URL}/api/v1/ai/analyze-tag`,
  AI_GENERATE_SUMMARY: `${API_BASE_URL}/api/v1/ai/generate-summary`,
  AI_BATCH_ANALYZE: `${API_BASE_URL}/api/v1/ai/batch-analyze`,
  AI_USAGE_STATS: `${API_BASE_URL}/api/v1/ai/usage-stats`,

  // Company Management endpoints
  COMPANY_CREATE: `${API_BASE_URL}/api/v1/company/create`,
  COMPANY_LIST: `${API_BASE_URL}/api/v1/company/list`,
  COMPANY_FILTER: `${API_BASE_URL}/api/v1/company/filter`,
  COMPANY_DETAILS: `${API_BASE_URL}/api/v1/company`,
  COMPANY_UPDATE: `${API_BASE_URL}/api/v1/company`,
  COMPANY_DELETE: `${API_BASE_URL}/api/v1/company`,
  COMPANY_ADD_USER: `${API_BASE_URL}/api/v1/company`,
  COMPANY_REMOVE_USER: `${API_BASE_URL}/api/v1/company`,
  COMPANY_ADD_PROJECT: `${API_BASE_URL}/api/v1/company`,
  COMPANY_REMOVE_PROJECT: `${API_BASE_URL}/api/v1/company`,
  COMPANY_BATCH_ADD_USERS: `${API_BASE_URL}/api/v1/company`,
  COMPANY_BATCH_ADD_PROJECTS: `${API_BASE_URL}/api/v1/company`,
  COMPANY_UPLOAD_LOGO: `${API_BASE_URL}/api/v1/company`,

  // Transcript Export with Evaluations
  TRANSCRIPT_EXPORT_EVALUATIONS: (projectId, startDate = null, endDate = null, limit = null, splitSize = null, includeMessages = true) => {
    let url = `${API_BASE_URL}/api/v1/transcripts/export/evaluations?project_id=${projectId}`;
    if (startDate) url += `&start_date=${startDate}`;
    if (endDate) url += `&end_date=${endDate}`;
    if (limit) url += `&limit=${limit}`;
    if (splitSize) url += `&split_size=${splitSize}`;
    url += `&include_messages=${includeMessages}`;
    return url;
  },

  // Upsell tracking & notifications endpoints
  UPSELL_TRACK: `${API_BASE_URL}/api/v1/upsell/track`,
  UPSELL_INTERACTIONS: `${API_BASE_URL}/api/v1/upsell/interactions`,
  UPSELL_UNREAD_COUNT: `${API_BASE_URL}/api/v1/upsell/unread-count`,
  UPSELL_MARK_READ: `${API_BASE_URL}/api/v1/upsell/mark-read`,
  UPSELL_MARK_ALL_READ: `${API_BASE_URL}/api/v1/upsell/mark-all-read`,
  UPSELL_STATISTICS: `${API_BASE_URL}/api/v1/upsell/statistics`,
  UPSELL_DELETE: (id) => `${API_BASE_URL}/api/v1/upsell/interactions/${id}`,

  // Booking / Customer Dashboard endpoints
  BOOKING_KPIS: `${API_BASE_URL}/api/v1/booking/kpis`,
  BOOKING_FUNNEL: `${API_BASE_URL}/api/v1/booking/funnel`,
  BOOKING_SESSIONS: `${API_BASE_URL}/api/v1/booking/sessions`,
  BOOKING_ABANDONED_CARTS: `${API_BASE_URL}/api/v1/booking/abandoned-carts`,
  BOOKING_INSIGHTS: `${API_BASE_URL}/api/v1/booking/insights`,
  BOOKING_TRENDS: `${API_BASE_URL}/api/v1/booking/trends`,
  BOOKING_CLIENTS: `${API_BASE_URL}/api/v1/booking/clients`,
  BOOKING_DEMAND_CALENDAR: `${API_BASE_URL}/api/v1/booking/demand-calendar`,
  BOOKING_BOOKING_WINDOW: `${API_BASE_URL}/api/v1/booking/booking-window`,
  BOOKING_PRICE_SENSITIVITY: `${API_BASE_URL}/api/v1/booking/price-sensitivity`,
  BOOKING_CROSS_BROWSE: `${API_BASE_URL}/api/v1/booking/cross-browse`,
  BOOKING_DAY_OF_WEEK: `${API_BASE_URL}/api/v1/booking/day-of-week`,
  BOOKING_RV_INTELLIGENCE: `${API_BASE_URL}/api/v1/booking/rv-intelligence`,
  BOOKING_PET_DEMAND: `${API_BASE_URL}/api/v1/booking/pet-demand`,
  RECOVERY_STATS: `${API_BASE_URL}/api/v1/booking/recovery/stats`,
  RECOVERY_TRENDS: `${API_BASE_URL}/api/v1/booking/recovery/trends`,
  RECOVERY_SEQUENCES: `${API_BASE_URL}/api/v1/booking/recovery/sequences`,
  RECOVERY_ACTIVITY: `${API_BASE_URL}/api/v1/booking/recovery/activity`,
  RECOVERY_CONFIG: `${API_BASE_URL}/api/v1/booking/recovery/config`,
  CART_EMAIL_GENERATE: `${API_BASE_URL}/api/v1/booking/cart-email/generate`,
  CART_EMAIL_SEND: `${API_BASE_URL}/api/v1/booking/cart-email/send`,
  CART_EMAIL_STATUS: `${API_BASE_URL}/api/v1/booking/cart-email/status`,

  // Feature toggle endpoints
  USER_FEATURES: `${API_BASE_URL}/api/v1/user`,
  MY_FEATURES: `${API_BASE_URL}/api/v1/user/my/features`,
  FEATURE_REGISTRY: `${API_BASE_URL}/api/v1/user/features/registry`,

  // Profile & Settings endpoints
  CHANGE_PASSWORD: `${API_BASE_URL}/api/v1/user/change-password`,
  UPLOAD_AVATAR: `${API_BASE_URL}/api/v1/user/avatar/upload`,
  REMOVE_AVATAR: `${API_BASE_URL}/api/v1/user/avatar/remove`,
  UPDATE_THEME: `${API_BASE_URL}/api/v1/user/theme`,
  ACTIVITY_LOG: `${API_BASE_URL}/api/v1/user/activity-log`,

  // Google Ads endpoints
  GOOGLE_ADS_FILTERS: `${API_BASE_URL}/api/v1/google-ads/filters`,
  GOOGLE_ADS_KPIS: `${API_BASE_URL}/api/v1/google-ads/kpis`,
  GOOGLE_ADS_BUDGET: `${API_BASE_URL}/api/v1/google-ads/budget-pacing`,
  GOOGLE_ADS_SPEND_TREND: `${API_BASE_URL}/api/v1/google-ads/spend-trend`,
  GOOGLE_ADS_WASTED_SPEND: `${API_BASE_URL}/api/v1/google-ads/wasted-spend`,
  GOOGLE_ADS_SEARCH_TERMS: `${API_BASE_URL}/api/v1/google-ads/search-terms`,
  GOOGLE_ADS_CAMPAIGNS: `${API_BASE_URL}/api/v1/google-ads/campaigns`,
  GOOGLE_ADS_DIM_DEVICE: `${API_BASE_URL}/api/v1/google-ads/dimensions/device`,
  GOOGLE_ADS_DIM_HOURLY: `${API_BASE_URL}/api/v1/google-ads/dimensions/hourly`,
  GOOGLE_ADS_DIM_DAY_OF_WEEK: `${API_BASE_URL}/api/v1/google-ads/dimensions/day-of-week`,
  GOOGLE_ADS_DIM_GEO: `${API_BASE_URL}/api/v1/google-ads/dimensions/geo`,
  GOOGLE_ADS_CONVERSIONS_BREAKDOWN: `${API_BASE_URL}/api/v1/google-ads/conversions/breakdown`,
  GOOGLE_ADS_AD_COPY_INSIGHTS: `${API_BASE_URL}/api/v1/google-ads/ads/copy-insights`,
  GOOGLE_ADS_RECOMMENDATIONS: `${API_BASE_URL}/api/v1/google-ads/recommendations`,
  GOOGLE_ADS_CLIENT_INFO: `${API_BASE_URL}/api/v1/google-ads/client-info`,
  GOOGLE_ADS_LAST_UPDATED: `${API_BASE_URL}/api/v1/google-ads/last-updated`,
  
  // Google Analytics (GA4) endpoints
  GA4_KPIS: `${API_BASE_URL}/api/v1/google-analytics/kpis`,
  GA4_TRAFFIC_TREND: `${API_BASE_URL}/api/v1/google-analytics/traffic-trend`,
  GA4_TRAFFIC: `${API_BASE_URL}/api/v1/google-analytics/traffic`,
  GA4_CHANNELS: `${API_BASE_URL}/api/v1/google-analytics/channels`,
  GA4_CHANNEL_TREND: `${API_BASE_URL}/api/v1/google-analytics/channel-trend`,
  GA4_SOURCE_MEDIUM: `${API_BASE_URL}/api/v1/google-analytics/source-medium`,
  GA4_SOURCE_MEDIUM_TREND: `${API_BASE_URL}/api/v1/google-analytics/source-medium-trend`,
  GA4_REFERRALS: `${API_BASE_URL}/api/v1/google-analytics/referrals`,
  GA4_REFERRAL_WINDOWS: `${API_BASE_URL}/api/v1/google-analytics/referrals/windows`,
  GA4_CAMPAIGNS: `${API_BASE_URL}/api/v1/google-analytics/campaigns`,
  GA4_PAGES: `${API_BASE_URL}/api/v1/google-analytics/pages`,
  GA4_PAGE_WINDOWS: `${API_BASE_URL}/api/v1/google-analytics/pages/windows`,
  GA4_LANDING_PAGES: `${API_BASE_URL}/api/v1/google-analytics/landing-pages`,
  GA4_GEO_WINDOWS: `${API_BASE_URL}/api/v1/google-analytics/geo/windows`,
  GA4_GEO_REGION: `${API_BASE_URL}/api/v1/google-analytics/geo/region`,
  GA4_GEO_CITY: `${API_BASE_URL}/api/v1/google-analytics/geo/city`,
  GA4_DEVICES: `${API_BASE_URL}/api/v1/google-analytics/devices`,
  GA4_BROWSERS: `${API_BASE_URL}/api/v1/google-analytics/browsers`,
  GA4_BROWSER_WINDOWS: `${API_BASE_URL}/api/v1/google-analytics/browsers/windows`,
  GA4_OPERATING_SYSTEMS: `${API_BASE_URL}/api/v1/google-analytics/operating-systems`,
  GA4_OS_WINDOWS: `${API_BASE_URL}/api/v1/google-analytics/operating-systems/windows`,
  GA4_EVENTS: `${API_BASE_URL}/api/v1/google-analytics/events`,
  GA4_CONVERSIONS: `${API_BASE_URL}/api/v1/google-analytics/conversions`,
  GA4_CONVERSIONS_BY_SOURCE: `${API_BASE_URL}/api/v1/google-analytics/conversions/by-source`,

  // GA4 Charts endpoints
  GA4_CHART_USER_TYPE: `${API_BASE_URL}/api/v1/google-analytics/charts/user-type`,
  GA4_CHART_HOURLY_TRAFFIC: `${API_BASE_URL}/api/v1/google-analytics/charts/hourly-traffic`,
  GA4_CHART_HOURLY_TRAFFIC_WINDOWS: `${API_BASE_URL}/api/v1/google-analytics/charts/hourly-traffic/windows`,
  GA4_CHART_DAY_OF_WEEK: `${API_BASE_URL}/api/v1/google-analytics/charts/day-of-week-traffic`,
  GA4_CHART_DAY_OF_WEEK_WINDOWS: `${API_BASE_URL}/api/v1/google-analytics/charts/day-of-week-traffic/windows`,
  GA4_LAST_UPDATED: `${API_BASE_URL}/api/v1/google-analytics/last-updated`,

  // CDP (Visitor Intelligence) endpoints
  CDP_ACTIVE_VISITORS: `${API_BASE_URL}/api/v1/cdp/active-visitors`,
  CDP_RECENT_EVENTS: `${API_BASE_URL}/api/v1/cdp/recent-events`,
  CDP_ENRICH_VISITOR: `${API_BASE_URL}/api/v1/cdp/enrich-visitor`,
  CDP_KPIS: `${API_BASE_URL}/api/v1/cdp/kpis`,
  CDP_TREND: `${API_BASE_URL}/api/v1/cdp/trend`,
  CDP_FUNNEL: `${API_BASE_URL}/api/v1/cdp/funnel`,
  CDP_SESSIONS: `${API_BASE_URL}/api/v1/cdp/sessions`,
  CDP_SEGMENTS: `${API_BASE_URL}/api/v1/cdp/segments`,
  CDP_CHANNEL_PERFORMANCE: `${API_BASE_URL}/api/v1/cdp/channels/performance`,
  CDP_CHANNEL_CQS: `${API_BASE_URL}/api/v1/cdp/channels/quality-score`,
  CDP_CHANNEL_ATTRIBUTION: `${API_BASE_URL}/api/v1/cdp/channels/attribution`,
  CDP_CHANNEL_PATHS: `${API_BASE_URL}/api/v1/cdp/channels/paths`,
  CDP_CHANNEL_FACEBOOK: `${API_BASE_URL}/api/v1/cdp/channels/facebook`,
  CDP_PEOPLE: `${API_BASE_URL}/api/v1/cdp/people`,
  CDP_KNOWN_RATIO: `${API_BASE_URL}/api/v1/cdp/people/known-ratio`,
  CDP_PERSON_PROFILE: `${API_BASE_URL}/api/v1/cdp/person/profile`,
  CDP_PERSON_JOURNEY: `${API_BASE_URL}/api/v1/cdp/person/journey`,
  CDP_AI_TECH: `${API_BASE_URL}/api/v1/cdp/ai-tech`,
  CDP_INSIGHTS: `${API_BASE_URL}/api/v1/cdp/insights`,
  CDP_LANDING_PAGES: `${API_BASE_URL}/api/v1/cdp/content/landing-pages`,
  CDP_CONTENT_INFLUENCE: `${API_BASE_URL}/api/v1/cdp/content/influence`,
  CDP_PEAK_HOURS: `${API_BASE_URL}/api/v1/cdp/content/peak-hours`,

  // Event Intelligence endpoints
  EI_ECP: `${API_BASE_URL}/api/v1/event-intelligence/ecp`,
  EI_AMI: `${API_BASE_URL}/api/v1/event-intelligence/ami`,
  EI_MARKETING_VELOCITY: `${API_BASE_URL}/api/v1/event-intelligence/marketing-velocity`,
  EI_PLAYBOOK_COVERAGE: `${API_BASE_URL}/api/v1/event-intelligence/playbook-coverage`,
  EI_SOURCE_DIVERSITY: `${API_BASE_URL}/api/v1/event-intelligence/source-diversity`,
  EI_TIMELINE: `${API_BASE_URL}/api/v1/event-intelligence/timeline`,
  EI_WEEKLY_DENSITY: `${API_BASE_URL}/api/v1/event-intelligence/weekly-density`,
  EI_OPPORTUNITIES: `${API_BASE_URL}/api/v1/event-intelligence/opportunities`,
  EI_PLAYBOOKS: `${API_BASE_URL}/api/v1/event-intelligence/playbooks`,
  EI_PLAYBOOK_DETAIL: (id) => `${API_BASE_URL}/api/v1/event-intelligence/playbooks/${encodeURIComponent(id)}`,
  EI_CATEGORY_AFFINITY: `${API_BASE_URL}/api/v1/event-intelligence/category-affinity`,
  EI_PROPERTY_EVENT_MATCH: `${API_BASE_URL}/api/v1/event-intelligence/property-event-match`,
  EI_SOURCE_COMPARISON: `${API_BASE_URL}/api/v1/event-intelligence/source-comparison`,
  EI_CATEGORY_DISTRIBUTION: `${API_BASE_URL}/api/v1/event-intelligence/category-distribution`,
  EI_PIPELINE_HEALTH: `${API_BASE_URL}/api/v1/event-intelligence/pipeline-health`,

  // CampVantage AI Monitor (AIM) endpoints
  AIM_RUNS: `${API_BASE_URL}/api/v1/aim/runs`,
  AIM_RUN_DETAIL: (id) => `${API_BASE_URL}/api/v1/aim/runs/${encodeURIComponent(id)}`,
  AIM_SNAPSHOT: (code) => `${API_BASE_URL}/api/v1/aim/snapshot/${encodeURIComponent(code)}`,
  AIM_SNAPSHOT_TREND: (code) => `${API_BASE_URL}/api/v1/aim/snapshot/${encodeURIComponent(code)}/trend`,
  AIM_RPC: (name) => `${API_BASE_URL}/api/v1/aim/rpc/${encodeURIComponent(name)}`,
  AIM_GROUND_TRUTH: `${API_BASE_URL}/api/v1/aim/ground-truth`,
  AIM_GROUND_TRUTH_EDIT: (id) => `${API_BASE_URL}/api/v1/aim/ground-truth/${encodeURIComponent(id)}`,
  AIM_GROUND_TRUTH_CHANGES: `${API_BASE_URL}/api/v1/aim/ground-truth/changes`,
  AIM_HALLUCINATIONS: `${API_BASE_URL}/api/v1/aim/hallucinations`,
  AIM_CONSENSUS_DETAIL: `${API_BASE_URL}/api/v1/aim/consensus-detail`,
  AIM_KNOWLEDGE_RECENCY: `${API_BASE_URL}/api/v1/aim/knowledge-recency`,
  AIM_KNOWLEDGE_RECENCY_TIMELINE: `${API_BASE_URL}/api/v1/aim/knowledge-recency/timeline`,
  AIM_CATEGORY_CONFUSION: `${API_BASE_URL}/api/v1/aim/category-confusion`,
  AIM_ORGANIC_RANKINGS: `${API_BASE_URL}/api/v1/aim/organic-rankings`,
  AIM_ORGANIC_RANKINGS_DETAIL: `${API_BASE_URL}/api/v1/aim/organic-rankings/detail`,
  AIM_AIO_PENETRATION: `${API_BASE_URL}/api/v1/aim/aio-penetration`,
  AIM_AIO_FUNNEL: `${API_BASE_URL}/api/v1/aim/aio-funnel`,
  AIM_POSITION_VOLATILITY: `${API_BASE_URL}/api/v1/aim/position-volatility`,
  AIM_SCORECARD: `${API_BASE_URL}/api/v1/aim/scorecard`,
  AIM_HEATMAP: `${API_BASE_URL}/api/v1/aim/heatmap`,
  AIM_KPIS: `${API_BASE_URL}/api/v1/aim/kpis`,
  AIM_SEARCH_LIFT: `${API_BASE_URL}/api/v1/aim/search-lift`,
  AIM_SENTIMENT: `${API_BASE_URL}/api/v1/aim/sentiment`,
  AIM_PROVIDER_CATEGORIES: (providerId) => `${API_BASE_URL}/api/v1/aim/provider/${encodeURIComponent(providerId)}/categories`,
  AIM_PROVIDER_FACTS: (providerId) => `${API_BASE_URL}/api/v1/aim/provider/${encodeURIComponent(providerId)}/facts`,
  AIM_PROVIDER_CITATIONS: (providerId) => `${API_BASE_URL}/api/v1/aim/provider/${encodeURIComponent(providerId)}/citations`,
  AIM_COMPETITOR_THREAT: `${API_BASE_URL}/api/v1/aim/competitor-threat`,
  AIM_SHARE_OF_VOICE: `${API_BASE_URL}/api/v1/aim/share-of-voice`,
  AIM_COMPETITOR_DETAIL: `${API_BASE_URL}/api/v1/aim/competitor-detail`,
  AIM_CITATION_SOURCES: `${API_BASE_URL}/api/v1/aim/citation-sources`,
  AIM_AMENITY_GAP: `${API_BASE_URL}/api/v1/aim/amenity-gap`,
  AIM_SYSTEM_RUNS: `${API_BASE_URL}/api/v1/aim/system/runs`,
  AIM_SYSTEM_QUEUE_HEALTH: `${API_BASE_URL}/api/v1/aim/system/queue-health`,
  AIM_SYSTEM_COST_SUMMARY: `${API_BASE_URL}/api/v1/aim/system/cost-summary`,
  AIM_SYSTEM_ERRORS: `${API_BASE_URL}/api/v1/aim/system/errors`,
  AIM_SYSTEM_DATA_COUNTS: `${API_BASE_URL}/api/v1/aim/system/data-counts`,

  // Route Intelligence endpoints
  RI_HEADLINE_ROUTES: `${API_BASE_URL}/api/v1/route-intelligence/headline/routes`,
  RI_HEADLINE_ORIGINS: `${API_BASE_URL}/api/v1/route-intelligence/headline/origins`,
  RI_HEADLINE_DRIVE_TIME: `${API_BASE_URL}/api/v1/route-intelligence/headline/drive-time`,
  RI_HEADLINE_GTI: `${API_BASE_URL}/api/v1/route-intelligence/headline/gti`,
  RI_MAP_ORIGINS: `${API_BASE_URL}/api/v1/route-intelligence/map/origins`,
  RI_MAP_DRIVE_DISTRIBUTION: `${API_BASE_URL}/api/v1/route-intelligence/map/drive-distribution`,
  RI_MAP_STATE_TABLE: `${API_BASE_URL}/api/v1/route-intelligence/map/state-table`,
  RI_MAP_ORIGIN_DETAIL: `${API_BASE_URL}/api/v1/route-intelligence/map/origin-detail`,
  RI_MAP_PARK: `${API_BASE_URL}/api/v1/route-intelligence/map/park`,
  RI_CORRIDORS: `${API_BASE_URL}/api/v1/route-intelligence/corridors`,
  RI_TRIP_ECONOMICS: `${API_BASE_URL}/api/v1/route-intelligence/trip-economics`,
  RI_CONGESTION_LEADERBOARD: `${API_BASE_URL}/api/v1/route-intelligence/congestion/leaderboard`,
  RI_CONGESTION_BY_CORRIDOR: `${API_BASE_URL}/api/v1/route-intelligence/congestion/by-corridor`,
  RI_MARKETS_CONVERSION: `${API_BASE_URL}/api/v1/route-intelligence/markets/conversion-by-distance`,
  RI_MARKETS_BOOKED_GUESTS: `${API_BASE_URL}/api/v1/route-intelligence/markets/booked-guests`,
  RI_FUEL_SUMMARY: `${API_BASE_URL}/api/v1/route-intelligence/fuel/summary`,
  RI_FUEL_CHEAPEST: `${API_BASE_URL}/api/v1/route-intelligence/fuel/cheapest`,
  RI_FUEL_TREND: `${API_BASE_URL}/api/v1/route-intelligence/fuel/trend`,
  RI_FUEL_BY_MARKET: `${API_BASE_URL}/api/v1/route-intelligence/fuel/by-market`,
  RI_HEALTH: `${API_BASE_URL}/api/v1/route-intelligence/health`,

  // Competitive Intelligence endpoints
  CI_SUMMARY: `${API_BASE_URL}/api/v1/competitive-intelligence/summary`,
  CI_AVAILABLE_FILTERS: `${API_BASE_URL}/api/v1/competitive-intelligence/available-filters`,
  CI_RATE_CALENDAR: `${API_BASE_URL}/api/v1/competitive-intelligence/rate-calendar`,
  CI_RATE_DETAIL: `${API_BASE_URL}/api/v1/competitive-intelligence/rate-detail`,
  CI_MARKET_POSITION: `${API_BASE_URL}/api/v1/competitive-intelligence/market-position`,
  CI_ACTIONS: `${API_BASE_URL}/api/v1/competitive-intelligence/actions`,
  CI_ACTIONS_DISMISS: (actionId) => `${API_BASE_URL}/api/v1/competitive-intelligence/actions/${encodeURIComponent(actionId)}/dismiss`,
  CI_COMPETITORS: `${API_BASE_URL}/api/v1/competitive-intelligence/competitors`,
  CI_COMPETITOR_DETAIL: `${API_BASE_URL}/api/v1/competitive-intelligence/competitors/detail`,
  CI_RATE_CHANGES: `${API_BASE_URL}/api/v1/competitive-intelligence/rate-changes`,
  CI_RATE_CHANGES_MARK_READ: `${API_BASE_URL}/api/v1/competitive-intelligence/rate-changes/mark-read`,

  // Competitive Intelligence — Section 8 Analysis Panels
  CI_REPORT_DEMAND_SIGNALS: `${API_BASE_URL}/api/v1/competitive-intelligence/reports/demand-signals`,
  CI_REPORT_PRICE_GAPS: `${API_BASE_URL}/api/v1/competitive-intelligence/reports/price-gaps`,
  CI_REPORT_WEEKDAY_WEEKEND: `${API_BASE_URL}/api/v1/competitive-intelligence/reports/weekday-weekend`,
  CI_REPORT_BOOKING_WINDOW: `${API_BASE_URL}/api/v1/competitive-intelligence/reports/booking-window`,
  CI_REPORT_EVENT_SPIKES: `${API_BASE_URL}/api/v1/competitive-intelligence/reports/event-spikes`,
  CI_REPORT_SITE_COMPARISON: `${API_BASE_URL}/api/v1/competitive-intelligence/reports/site-comparison`,
  CI_REPORT_AVAILABILITY_TRENDS: `${API_BASE_URL}/api/v1/competitive-intelligence/reports/availability-trends`,
  CI_REPORT_PRICE_DISTRIBUTION: `${API_BASE_URL}/api/v1/competitive-intelligence/reports/price-distribution`,
  CI_REPORT_REVENUE_OPPORTUNITY: `${API_BASE_URL}/api/v1/competitive-intelligence/reports/revenue-opportunity`,
  CI_REPORT_HIGH_VALUE_DATES: `${API_BASE_URL}/api/v1/competitive-intelligence/reports/high-value-dates`,
  CI_REPORT_DYNAMIC_PRICING: `${API_BASE_URL}/api/v1/competitive-intelligence/reports/dynamic-pricing`,
  CI_REPORT_COMPETITIVE_RANKING: `${API_BASE_URL}/api/v1/competitive-intelligence/reports/competitive-ranking`,
  CI_REPORT_INVENTORY_CONCENTRATION: `${API_BASE_URL}/api/v1/competitive-intelligence/reports/inventory-concentration`,
  CI_REPORT_COMPETITOR_VULNERABILITY: `${API_BASE_URL}/api/v1/competitive-intelligence/reports/competitor-vulnerability`,
  CI_REPORT_RATE_INTEGRITY: `${API_BASE_URL}/api/v1/competitive-intelligence/reports/rate-integrity`,
  CI_REPORT_DOW_HEATMAP: `${API_BASE_URL}/api/v1/competitive-intelligence/reports/dow-heatmap`,
  CI_REPORT_FORWARD_CALENDAR: `${API_BASE_URL}/api/v1/competitive-intelligence/reports/forward-calendar`,
  CI_REPORT_MARKET_POSITION_DETAIL: `${API_BASE_URL}/api/v1/competitive-intelligence/reports/market-position`,
  CI_REPORT_DOW_REVENUE_HEATMAP: `${API_BASE_URL}/api/v1/competitive-intelligence/reports/dow-revenue-heatmap`,
  CI_REPORT_ABSORPTION_VELOCITY: `${API_BASE_URL}/api/v1/competitive-intelligence/reports/absorption-velocity`,
  CI_REPORT_ABSORPTION_VS_BASELINE: `${API_BASE_URL}/api/v1/competitive-intelligence/reports/absorption-vs-baseline`,
  CI_REPORT_ABSORPTION_HISTORY: `${API_BASE_URL}/api/v1/competitive-intelligence/reports/absorption-history`,
  CI_REPORT_MARKET_ABSORPTION: `${API_BASE_URL}/api/v1/competitive-intelligence/reports/market-absorption`,
  CI_REPORT_DEMAND_INDEX: `${API_BASE_URL}/api/v1/competitive-intelligence/reports/demand-index`,
  CI_TRENDS: `${API_BASE_URL}/api/v1/competitive-intelligence/trends`,
  CI_HOLIDAY_PREMIUMS: `${API_BASE_URL}/api/v1/competitive-intelligence/holiday-premiums`,

  // Weather Intelligence endpoints
  WI_INTELLIGENCE: `${API_BASE_URL}/api/v1/weather-intelligence`,
  WI_DATES: `${API_BASE_URL}/api/v1/weather-intelligence/dates`,
  WI_DETAIL: `${API_BASE_URL}/api/v1/weather-intelligence/detail`,

  // Campaign drill-down endpoints — use as: GOOGLE_ADS_CAMPAIGNS + '/' + encodedCampaignName + '/overview' etc.
  // /api/v1/google-ads/campaigns/:campaignName/overview
  // /api/v1/google-ads/campaigns/:campaignName/search-terms
  // /api/v1/google-ads/campaigns/:campaignName/keywords
  // /api/v1/google-ads/campaigns/:campaignName/ad-groups
  // /api/v1/google-ads/campaigns/:campaignName/ads
  // /api/v1/google-ads/campaigns/:campaignName/settings
};

